export default __webpack_public_path__ + "static/1887-629e0351814863bbfdad6a0839fabc42.gif";